import { render } from "./VideoPreview.vue?vue&type=template&id=33a32aee&scoped=true"
import script from "./VideoPreview.vue?vue&type=script&lang=js"
export * from "./VideoPreview.vue?vue&type=script&lang=js"

import "./VideoPreview.vue?vue&type=style&index=0&id=33a32aee&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-33a32aee"

export default script